import React, { FC } from "react";
import { TooltipProps } from "./types";
import Popper from "../popper";
import Paragraph from "../typography/paragraph";
import { Content as StyledContent } from "./styled-components";

export const Tooltip: FC<TooltipProps> = ({
  children,
  content,
  placement = "top-mid",
  isDarkMode = false,
  isDisabled = false,
  qaLabel,
  layer = 1999,
  ...rest
}) => (
  <Popper
    on="hover"
    placement={placement}
    isDisabled={isDisabled}
    layer={layer}
    content={
      <StyledContent
        qaLabel={qaLabel}
        variant={isDarkMode ? "light" : "dark"}
        placement={placement}
        {...rest}
      >
        <Paragraph
          color={isDarkMode ? "blue.900" : "white.900"}
          qaLabel="tooltip-text"
          fontSize="xs"
        >
          {content}
        </Paragraph>
      </StyledContent>
    }
  >
    {children}
  </Popper>
);

export * from "./types";
export default Tooltip;
